module.exports = new __parcel__URL__("starline.7ea31989.webp").toString();